import _ from 'lodash'
import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { getShopsList } from '../API/root'
import Loading from './partials/Loading'
import { useDispatch, useSelector } from 'react-redux'
import ReactGA from 'react-ga4'
import { Rating } from '@smastrom/react-rating'
import { formatCart } from '../API/Cart'
import { IoCallOutline } from 'react-icons/io5'

const ShopsForCustomDocuments = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const seachQuery = useSearchParams()[0]

  const navbar_height = useSelector((state) => state.navbar_height)
  const cart = useSelector((state) => state.cart)

  const { required_sizes_types } = formatCart(cart)

  const [isLoading, setIsLoading] = useState(true)
  const [shops, setShops] = useState([])

  const filterShops = (shop_temp) => {
    // To be part of typesense query TODO
    shop_temp = _.filter(
      shop_temp,
      (shop) =>
        _.difference(required_sizes_types, shop.sizes_types).length === 0
    )
    return shop_temp
  }

  const getData = async () => {
    let shop_temp = await getShopsList({
      has_notes: false,
    })
    shop_temp = filterShops(shop_temp)
    shop_temp = _.sortBy(shop_temp, 'name')
    setShops(shop_temp)
    setIsLoading(false)
  }

  const referenceNum = seachQuery.get('reference')

  const onClickShop = (shop) => {
    for (const item of cart) {
      const data = { ...item, shop_id: shop['id'], shop }
      dispatch({ type: 'UPDATE_CART_ITEM', key: item.key, data })
    }
    navigate(-1)
  }

  useEffect(() => {
    if (referenceNum) {
      dispatch({ type: 'CLEAR_CART' })
    }
  }, [referenceNum])

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname,
      title: 'Shops for Custom Documents',
    })
    getData()
  }, [])

  if (isLoading) {
    return <Loading />
  }

  return (
    <div
      className="flex justify-center"
      style={{ marginTop: `${navbar_height + 16}px` }}
    >
      {/* <Heading title="Shops" Icon={FiUser} IconNavigateTo={'/my-orders'} /> */}
      {_.map(shops, (shop, index) => {
        const rating = shop['rating'] ? shop['rating'] : null
        const rating_count = shop['rating_count'] ? shop['rating_count'] : null
        return (
          <div
            className="border border-surface px-4 py-4 md:w-1/2 lg:w-11/12
                        inline-block mb-4 rounded-lg mx-4 cursor-pointer hover:bg-surface"
            key={index}
            onClick={() => onClickShop(shop)}
          >
            <div className="text-lg font-semibold">{shop.name}</div>
            {rating ? (
              <div className="flex items-center my-1">
                <Rating style={{ maxWidth: 80 }} value={rating} readOnly />
                {rating_count ? (
                  <div className="text-sm mx-2 inline-block text-onBackground">
                    ({rating_count})
                  </div>
                ) : null}
              </div>
            ) : null}
            {shop.no_of_pending_orders && shop.no_of_pending_orders > 0 ? (
              <div className="mt-1 font-semibold text-sm">
                {shop.no_of_pending_orders} in queue
              </div>
            ) : null}
            <div className="mt-2">{shop.primary_address}</div>
            <div className="mt-1 text-sm">{shop.secondary_address}</div>
            {shop['phone'] ? (
              <div className="mt-2 inline-flex flex-row items-center text-sm pr-2">
                <IoCallOutline className="pr-2 text-xl" />
                {shop['phone']}
              </div>
            ) : null}
          </div>
        )
      })}
    </div>
  )
}

export default ShopsForCustomDocuments
